import f from "../assets/mixins/emitter.js";
import { R as g, a as S } from "../select-a3242b31.js";
import { resolveComponent as h, openBlock as m, createBlock as d, withCtx as N, createElementBlock as C, Fragment as I, renderList as M } from "vue";
import { _ as D } from "../_plugin-vue_export-helper-dad06003.js";
import "../utils/gogocodeTransfer.js";
import "../assets/mixins/focus.js";
import "element-plus";
import "../scrollbar2-f7c66394.js";
import "../assets/utils/scrollbar-width.js";
import "../util-b2b0dc25.js";
import "../assets/utils/dom.js";
import "../scrollbar2/util.js";
import "../assets/utils/vue-popper.js";
import "../assets/utils/popup/popup-manager.js";
import "../assets/utils/popper.js";
import "../assets/mixins/event.js";
import "../virtual-list/index.js";
import "../virtual-list-6f8b6d25.js";
import "../icon-51ff7679.js";
import "../_commonjsHelpers-ce4d82cc.js";
import "../isSymbol-62c14278.js";
import "../toNumber-ea93c45b.js";
import "../assets/utils/clickoutside.js";
import "../assets/utils/scroll-into-view.js";
import "../select/src/navigation-mixin.js";
import "../assets/utils/shared.js";
const p = {
  SPOT: "spot",
  MARGIN: "margin",
  FUTURES: "futures"
}, L = {
  symbolId: 53,
  symbolName: "BTC/USDT",
  coinList: [
    {
      coinId: 2,
      iconUrl: "/static-file/public/coin/BTC-20200604060942.png",
      coinName: "Bitcoin",
      coinShortName: "BTC"
    },
    {
      coinId: 17,
      iconUrl: "/static-file/public/coin/USDT-20200604062641.png",
      coinName: "Tether USD",
      coinShortName: "USDT"
    }
  ]
}, T = {
  name: "rSymbolSelector",
  model: {
    prop: "modelValue",
    event: "item-change"
  },
  mixins: [f],
  components: {
    RSelect: g,
    ROption: S
  },
  props: {
    /**
     * 交易对id
     */
    modelValue: {
      type: [Number, String],
      default: null
    },
    /**
     * spot: 现货
     * margin: 杠杆
     */
    tradeMode: {
      type: String,
      default: "spot"
    },
    /**
     * 接口返回数据
     */
    responseData: {
      type: Array,
      default: () => []
    },
    /**
     * 主动传入组件所需格式的交易对列表(优先级比responseData高)
     */
    symbolList: {
      type: Array,
      default: () => []
    },
    /**
     * 是否加载中
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * 选择框尺寸
     */
    size: {
      type: String,
      default: "small"
    },
    /**
     * 选择框宽度
     */
    width: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      renderData: {
        list: [],
        pageSize: 20,
        current: 0,
        finished: !1
      },
      queryText: "",
      optionsAll: [
        {
          symbolId: "",
          symbolName: this.$t("bmui-symbol-cascader.all"),
          coinList: []
        }
      ]
    };
  },
  computed: {
    symbolIdMap() {
      return this.list.reduce((t, i) => Object.assign(t, {
        [i.symbolId]: i
      }), {});
    },
    optionList() {
      return this.queryText ? this.list.filter((t) => t.symbolName.toUpperCase().includes(this.queryText.toUpperCase())) : this.renderData.list;
    }
  },
  watch: {
    responseData: {
      handler(t) {
        t && t.length && this.handleParamsChange(this.tradeMode);
      },
      immediate: !0
    },
    tradeMode: {
      handler(t) {
        this.handleParamsChange(t);
      },
      immediate: !0
    },
    symbolList: {
      handler(t) {
        t && t.length && this.handleParamsChange(this.tradeMode);
      },
      immediate: !0
    }
  },
  methods: {
    handleParamsChange(t) {
      if (this.symbolList && this.symbolList.length) {
        const i = JSON.parse(JSON.stringify(this.symbolList));
        this.list = [...this.optionsAll, ...i], this.renderData.current = 0, this.renderData.list = [], this.loadMore();
        return;
      }
      this.setList(t);
    },
    setList(t) {
      switch (t) {
        case p.SPOT:
          this.setSpotSymbolList();
          break;
        case p.MARGIN:
          this.setMarginSymbolList();
          break;
      }
    },
    setSpotSymbolList() {
      const t = [], i = {}, n = {};
      for (const e of this.responseData)
        n[e.coinShortName] = e;
      for (const e of this.responseData)
        if (e.tradingPair && e.tradingPair.length && e.coinType !== 17) {
          for (const s of e.tradingPair)
            if (!i[s.symbol]) {
              const [o, l] = s.tag.split("/"), r = n[o], a = n[l];
              t.push({
                symbolId: s.symbol,
                symbolName: s.tag,
                coinList: [
                  {
                    coinId: r.coinType,
                    iconUrl: r.iconUrl,
                    coinName: r.coinName,
                    coinShortName: o
                  },
                  {
                    coinId: a.coinType,
                    iconUrl: a.iconUrl,
                    coinName: a.coinName,
                    coinShortName: l
                  }
                ]
              }), i[s.symbol] = e;
            }
        }
      this.list = [...this.optionsAll, ...t], this.loadMore();
    },
    setMarginSymbolList() {
      const t = this.responseData.map((i) => {
        const {
          tradeMappingId: n,
          tradeMappingName: e,
          coinId: s,
          coinUrl: o,
          coinFullName: l,
          coinName: r,
          marketCoinId: a,
          marketCoinUrl: u,
          marketCoinFullName: y,
          marketCoinName: b
        } = i;
        return {
          symbolId: n,
          symbolName: e,
          coinList: [
            {
              coinId: s,
              iconUrl: o,
              coinName: l,
              coinShortName: r
            },
            {
              coinId: a,
              iconUrl: u,
              coinName: y,
              coinShortName: b
            }
          ]
        };
      });
      this.list = [...this.optionsAll, ...t], this.renderData.current = 0, this.renderData.list = [], this.loadMore();
    },
    handleChange(t) {
      this.$emit("update:modelValue", t), this.$emit("change", this.symbolIdMap[t]);
    },
    onReachBottom() {
      this.loadMore();
    },
    loadMore() {
      var s, o;
      const { current: t, pageSize: i, list: n } = this.renderData, e = this.list.slice(
        t * i,
        ++this.renderData.current * i
      );
      if (e.length < i && ((s = e[0]) == null ? void 0 : s.symbolId) !== "") {
        this.broadcast("rSelect", "unBindObserve"), this.broadcast("rSelect", "loadFinished");
        return;
      }
      e.length === 1 && ((o = e[0]) == null ? void 0 : o.symbolId) === "" && e.push(L), this.renderData.list = [...n, ...e];
    },
    query(t) {
      this.queryText = t;
    },
    onVisibleChange(t) {
      t || (this.queryText = "");
    }
  }
};
function U(t, i, n, e, s, o) {
  const l = h("ROption"), r = h("RSelect");
  return m(), d(r, {
    class: "r-symbol-selector",
    value: n.modelValue,
    lazyLoad: "",
    filterable: "",
    filterMethod: o.query,
    width: n.width,
    onChange: o.handleChange,
    onReachBottom: o.onReachBottom,
    onVisibleChange: o.onVisibleChange
  }, {
    default: N(() => [
      (m(!0), C(
        I,
        null,
        M(o.optionList, (a) => (m(), d(l, {
          label: a.symbolName,
          value: a.symbolId,
          key: a.symbolId
        }, null, 8, ["label", "value"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    _: 1
    /* STABLE */
  }, 8, ["value", "filterMethod", "width", "onChange", "onReachBottom", "onVisibleChange"]);
}
const c = /* @__PURE__ */ D(T, [["render", U], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/symbol-selector/symbol-selector.vue"]]);
c.install = function(t) {
  t.component(c.name, c);
};
export {
  c as default
};
